var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageNotificationSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 63,
    fill: "#C7FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 10.5H22.1C17.3396 10.5 14.9593 10.5 13.1411 11.3583C11.5417 12.1133 10.2414 13.318 9.42644 14.7998C8.5 16.4844 8.5 18.6896 8.5 23.1V36.75C8.5 39.1912 8.5 40.4118 8.78963 41.4132C9.5756 44.1308 11.8668 46.2535 14.8 46.9817C15.881 47.25 17.1984 47.25 19.8333 47.25V53.3807C19.8333 54.7794 19.8333 55.4788 20.1428 55.838C20.412 56.1504 20.8201 56.3321 21.2515 56.3317C21.7476 56.3312 22.3371 55.8943 23.516 55.0205L30.2748 50.0111C31.6555 48.9877 32.3458 48.476 33.1145 48.1122C33.7966 47.7894 34.5225 47.5534 35.2728 47.4108C36.1184 47.25 37.0025 47.25 38.7706 47.25H43.0667C47.8271 47.25 50.2073 47.25 52.0256 46.3917C53.625 45.6367 54.9253 44.432 55.7402 42.9502C56.6667 41.2656 56.6667 39.0604 56.6667 34.65V34.125M57.0104 10.1815C60.3299 13.2569 60.3299 18.2431 57.0104 21.3185C53.691 24.3938 48.309 24.3938 44.9896 21.3185C41.6701 18.2431 41.6701 13.2569 44.9896 10.1815C48.309 7.10616 53.691 7.10616 57.0104 10.1815Z",
    stroke: "#2B3D4F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageNotificationSquare);
export default __webpack_public_path__ + "static/media/message-notification-square.ce78a5854d52ccd6989c7ef365763c39.svg";
export { ForwardRef as ReactComponent };